import { motion } from "framer-motion";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1765896387377-e293914d1e69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxjYXJlZ2l2ZXIlMjBzZW5pb3IlMjBzbWlsaW5nJTIwaG9tZXxlbnwwfHx8fDE3NzgzNTczMzV8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section id="about" className="py-20 md:py-32 bg-[#EEF4F8]" data-testid="about-section">
      <div className="container-pad mx-auto max-w-7xl grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5 relative lg:sticky lg:top-28"
        >
          <div className="rounded-[2rem] overflow-hidden soft-shadow">
            <img
              src={ABOUT_IMG}
              alt="Caregiver and senior laughing together at home"
              className="w-full h-[420px] md:h-[520px] object-cover"
              data-testid="about-image"
            />
          </div>
          <div className="absolute -top-6 -right-6 md:-right-10 hidden md:block">
            <div className="bg-[#1E5F8C] text-[#F8FAFC] rounded-2xl px-5 py-4 max-w-[240px]">
              <p className="font-serif text-2xl leading-tight">Since 2022</p>
              <p className="text-xs uppercase tracking-widest opacity-80 mt-1">Backed by 15+ yrs of healthcare experience</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-[#2A9D8F] mb-5">
            About Julicare Health Services
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0F2942] leading-[1.1]" data-testid="about-heading">
            Care that honors the people you love.
          </h2>

          <div className="mt-6 space-y-4 text-base md:text-lg leading-relaxed text-[#475569]">
            <p>
              Established in 2022, Julicare Health Services is backed by over 15
              years of healthcare experience since 2007 in hospital, community,
              and private care settings. We are committed to providing
              compassionate, respectful, and dependable in-home care that
              allows seniors and individuals to remain safe, comfortable, and
              independent in the familiarity of their own homes.
            </p>
            <p>
              At Julicare Health Services, we understand that every client has
              unique needs and deserves personalized support delivered with
              patience, dignity, and kindness. Our services include personal
              care assistance, companionship, meal preparation, medication
              reminders, overnight care, respite support, and light
              housekeeping to help maintain a clean, safe, and comfortable
              environment.
            </p>
            <p>
              We believe quality care goes beyond daily tasks. It is about
              building trust, offering emotional support, and creating
              meaningful relationships with the individuals and families we
              serve. Our goal is to provide peace of mind to families while
              ensuring clients feel valued, respected, and cared for at all
              times.
            </p>
            <p>
              Julicare Health Services proudly serves
              <span className="text-[#0F2942] font-semibold"> Mississauga, Milton, Oakville, Burlington, Brampton, </span>
              and surrounding areas, providing reliable and compassionate home
              care support families can trust.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-3" data-testid="about-service-areas">
            {["Mississauga", "Milton", "Oakville", "Burlington", "Brampton"].map((c) => (
              <span
                key={c}
                className="inline-flex items-center rounded-full bg-[#F8FAFC] border border-[#1E5F8C]/15 text-[#0F2942] px-4 py-2 text-sm"
              >
                {c}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
